import React, { useState, useEffect } from 'react';
import useIsLogged from '../utils/useIsLogged';

const PlannedMaintenanceWarning = ({ className = '' }) => {
  const [isVisible, setIsVisible] = useState(true);
  const isLogged = useIsLogged();

  const STORAGE_KEY = 'plannedMaintenanceWarningClosed';

  useEffect(() => {
    // Check if the warning was already closed
    const wasClosed = sessionStorage.getItem(STORAGE_KEY);
    if (wasClosed === 'true') {
      setIsVisible(false);
    }
  }, []);

  if (!isVisible) {
    return null;
  }

  const handleClose = () => {
    setIsVisible(false);
    // Save to session storage that the warning was closed
    sessionStorage.setItem(STORAGE_KEY, 'true');
  };

  const getContent = () => {
    if (isLogged) {
      return {
        title: "⚠️ Actualizare programată în platforma Uniprest Instal Digital ⚠️",
        description: `
          <p>În această seară, 7 august, între orele 19:00 - 22:00, platforma Uniprest Instal Digital va fi temporar indisponibilă, ca urmare a unei intervenții tehnice asupra paginilor publice ale site-ului Uniprest.</p>
          <p>Platforma în sine nu suferă nicio modificare - o mutăm doar pe un subdomeniu nou, pentru o structură mai clară. Funcționalitățile și conținutul rămân exact la fel.</p>
          <p><b>Îți mulțumim pentru înțelegere!</b></p>
        `
      };
    } else {
      return {
        title: "⚠️  Intervenție programată pe site ⚠️",
        description: "<p>În această seară, 7 august, între orele 19:00 - 22:00, site-ul nostru va lua o scurtă pauză pentru a face loc unei versiuni îmbunătățite. În acest interval, platforma nu va fi disponibilă pentru accesare. </p><b>Îți mulțumim pentru înțelegere!</b>"
      };
    }
  };

  const content = getContent();

  return (
    <div className={`planned-maintenance-warning ${className}`}>
      <div className="planned-maintenance-warning__header">
        <h4 className="planned-maintenance-warning__title">
          {content.title}
        </h4>
        <button
          onClick={handleClose}
          className="planned-maintenance-warning__close-button"
          title="Închide"
        >
          ×
        </button>
      </div>
      <div
        className="planned-maintenance-warning__content"
        dangerouslySetInnerHTML={{ __html: content.description }}
      />
    </div>
  );
};

export default PlannedMaintenanceWarning;